import { useEffect } from "react";

/** Light PWA: swap manifest, theme color and home-screen icon while the page is open. No service worker (R40). */
export function useAppManifest(manifestFile: string, themeColor: string, iconFile: string, enabled = true): void {
  useEffect(() => {
    if (!enabled) return undefined;
    const publicUrl = process.env.PUBLIC_URL || "";
    const manifest = document.querySelector('link[rel="manifest"]');
    const theme = document.querySelector('meta[name="theme-color"]');
    const apple = document.querySelector('link[rel="apple-touch-icon"]');
    const prevManifest = manifest?.getAttribute("href");
    const prevTheme = theme?.getAttribute("content");
    const prevApple = apple?.getAttribute("href");

    if (manifest) {
      manifest.setAttribute("href", `${publicUrl}/${manifestFile}`);
    }
    if (theme) {
      theme.setAttribute("content", themeColor);
    }
    if (apple) {
      apple.setAttribute("href", `${publicUrl}/${iconFile}`);
    }

    return () => {
      if (manifest && prevManifest) {
        manifest.setAttribute("href", prevManifest);
      }
      if (theme && prevTheme) {
        theme.setAttribute("content", prevTheme);
      }
      if (apple && prevApple) {
        apple.setAttribute("href", prevApple);
      }
    };
  }, [manifestFile, themeColor, iconFile, enabled]);
}

export function useCollectorPwa(): void {
  useAppManifest("my-collection-manifest.json", "#7e462a", "my-collection-icon-192.png");
}

/** HKP Karkhana as its own home-screen app for supervisors; opens at the sign-in page, which renews the login. */
export function useKarkhanaPwa(enabled = true): void {
  useAppManifest("karkhana-manifest.json", "#ffffff", "karkhana-icon-192.png", enabled);
}
